import React from 'react';

import SchemaInterfaceFieldTable, {BaseSchemaInterfaceFieldTableProps} from './SchemaInterfaceFieldTable';
import {ClientInterfaceField} from './SchemaInterfaceUtils';

export interface SchemaInterfaceCreateFieldTableProps extends BaseSchemaInterfaceFieldTableProps {
  onFieldsChange: (clientInterfaceFields: Array<ClientInterfaceField>) => void;
}

export function SchemaInterfaceCreateFieldTable(props: SchemaInterfaceCreateFieldTableProps): JSX.Element {
  return <SchemaInterfaceFieldTable {...props} isBeingCreated={true} submissionWarnings={[]} />;
}

export default SchemaInterfaceCreateFieldTable;
